<template>
  <v-card class="ma-4 ma-lg-8" elevation="4" rounded="lg">
    <v-btn
      v-if="showClose"
      :icon="mdiClose"
      aria-label="Close Contact Form"
      location="top right"
      position="absolute"
      variant="text"
      @click="$emit('close')"
    />

    <v-container class="mt-2" fluid>
      <v-row v-if="value.title || value.paragraph">
        <v-col class="text-center" cols="12">
          <TitleParagraphBlock :value="value" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <ContactForm
            :agreement="value.agreement"
            :default-inquiry-type="value.default_inquiry_type"
            :default-inquiry-product="value.default_inquiry_product"
            :fields="{
              inquiryProduct: !value.default_inquiry_product,
              inquiryType: !value.default_inquiry_type
            }"
            :hubspot-form-id="value.hubspot_form_id"
            :hubspot-portal-id="value.hubspot_portal_id"
            :multi-step="value.is_multi_step"
            :submit-text="value.submit_text || 'Submit'"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import { mdiClose } from '@mdi/js'

defineProps({
  showClose: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

defineEmits(['close'])
</script>
